import { all } from "redux-saga/effects";
import { adminWatcher } from "./actions/admin/Saga";
import { registerWatcher } from "./actions/auth";
import { ordersWatcher } from "./actions/orders";

export function* rootSagas() {
  yield all([adminWatcher(), ordersWatcher(), registerWatcher()]);
}
